"use client";
import * as React from "react";
const SvgFavoriteSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 15.5-1.16-1.08C2.72 10.6 0 8.1 0 5A4.4 4.4 0 0 1 4.4.5c1.4 0 2.73.66 3.6 1.7A4.8 4.8 0 0 1 11.6.5 4.4 4.4 0 0 1 16 5c0 3.09-2.72 5.6-6.84 9.43z" }));
export {
  SvgFavoriteSharp as default
};
